import mockLanguageMessages from '../../languageProvider/locales/el_GR';

const getLanguageMessagesService = (language) => {
  const mockReplySuccess = {
    status: 1,
    results: mockLanguageMessages
  };

  const requestPromise = new Promise((resolve) => {
    window.setTimeout(function () {
      resolve(mockReplySuccess);
    }, 100);
  });

  return requestPromise;
};


export {getLanguageMessagesService}
